import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import DealerStoreIdClient from "../../../shared/clients/DealerStoreIdClient";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";
import styles from "../storeId/StoreId.module.scss";
import Grid from "@material-ui/core/Grid";
import { AVAILABLE_MARKETS } from "../../search/searchWrapper/orders/AvailableMarkets";
import { logMsg } from "../../../common/Logger";
import HasPermissionTo from "../../../common/HasPermissionTo";

class MerchantId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      isDataLoaded: false,
      market: null,
      savedStoreId: null,
      newStoreId: null,
    };

    this.uploadStoreIds = this.uploadStoreIds.bind(this);
  }

  componentDidMount() {
    this.getMerchantId();
  }

  getMerchantId() {
    this.props.hideOrShow(true);
    DealerStoreIdClient.getMerchantId(
      this.props.user,
      this.props.selectedMarket
    )
      .then((res) => {
        const storeIdData = res.result.dealerStoreIdData[0];
        this.setState({
          market: storeIdData.market,
          savedStoreId: storeIdData.storeId.toString(),
          newStoreId: storeIdData.storeId.toString(),
          buttonDisabled: true,
        });
      })
      .catch(() => {})
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ isDataLoaded: true });
      });
  }

  storeIdChangeHandler = (event) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      newStoreId: value,
      buttonDisabled: value === prevState.savedStoreId,
    }));
  };

  uploadStoreIds() {
    const merchantIds = [];
    merchantIds.push({
      storeId: this.state.newStoreId,
      updatedBy: this.props.user.userId,
    });
    DealerStoreIdClient.saveStoreIds(merchantIds, this.props.user.token)
      .then(() => {
        this.getMerchantId();
      })
      .catch((err) => logMsg(err))
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  render() {
    return (
      this.state.isDataLoaded && (
        <div className="pageWrapper">
          <div className="pagePadding">
            <h1 id="storeIdHeader" className="pageTitle">
              {this.props.t("StoreId.bluesnapHeader")}
            </h1>
            <div className="pageInfoWrapper">
              <InfoIconWithMessage
                message={this.props.t("StoreId.subheaderBluesnapFromB")}
              />
            </div>
          </div>

          <Grid
            container
            className={`${styles.columnHeaderRow} pagePaddingLeft pagePaddingRight`}
          >
            <Grid item xs={10} className={styles.columnHeader} id="site">
              {this.props.t("StoreId.site")}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${styles.columnHeader} ${styles.extraPaddingRight}`}
              id="storeId"
            >
              {this.props.t("StoreId.bluesnapId")}
            </Grid>
          </Grid>

          <ValidatorForm
            id="storeIdForm"
            ref={this.props.formRef}
            onSubmit={this.uploadStoreIds}
          >
            <Grid
              container
              key={this.state.market}
              className={`${styles.dataRow} pagePaddingLeft pagePaddingRight`}
            >
              <Grid item xs={10} className={styles.dataRowCell}>
                {AVAILABLE_MARKETS[this.state.market]}
              </Grid>
              <Grid item xs={2}>
                <HasPermissionTo
                  perform={["storeId:write"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => {
                    return (
                      <TextValidator
                        data-testid="inputField"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        name={this.state.market}
                        className={styles.storeIdInput}
                        variant="outlined"
                        value={this.state.newStoreId}
                        onChange={this.storeIdChangeHandler}
                        validators={[
                          "required",
                          "matchRegexp:^acct_[a-zA-Z0-9]{16}$",
                        ]}
                        errorMessages={[
                          this.props.t("StoreId.errorReq"),
                          this.props.t("StoreId.errorId"),
                        ]}
                      />
                    );
                  }}
                  noRender={() => {
                    return (
                      <div className={styles.storeIdText}>
                        {this.state.savedStoreId}
                      </div>
                    );
                  }}
                />
              </Grid>
            </Grid>
            <HasPermissionTo
              perform={["storeId:write"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => {
                return (
                  <div
                    className={
                      this.state.buttonDisabled
                        ? "disabledButtonDiv"
                        : "confirmButton"
                    }
                  >
                    <button
                      disabled={this.state.buttonDisabled}
                      data-testid="saveBtn"
                      id="saveBtn"
                      type="submit"
                    >
                      {this.props.t("StoreId.saveAndUpdate")}
                    </button>
                  </div>
                );
              }}
            />
          </ValidatorForm>
        </div>
      )
    );
  }
}

export default withTranslation("emp")(MerchantId);
